import {Component, h, State, Prop, Event, EventEmitter} from '@stencil/core';
import {localStore, translate} from "../../../utils/utils";
import {DateTime} from "luxon";
import axios from 'axios';
import {ShopTheme} from "../../../models/shop.model";

@Component({
  tag: 'ike-order-cashless',
  styleUrl: 'ike-order-cashless.scss',
  shadow: false,
})
export class IkeOrderCashless {
  uuid = null;
  @Prop() theme: ShopTheme;
  @State() cart:any;
  @State() config:any;
  @State() url:any;
  @State() hasError = false;
  @State() selected = null;
  @State() iframeLoading = false;
  @Event() getUtils: EventEmitter;
  private utils: any;
  private tickets: any;
  private passes: any;
  componentWillLoad() {
    this.getUtils.emit(utils=>this.utils=utils);
    this.uuid = this.utils.route.get('uuid')

    localStore.setItem(this.uuid, '');
    this.utils.storage.set('uuid', '');

    this.utils.http('get', '/cart').then( cart => {
      this.utils.store.set('cart', cart)
    });

    this.utils.http('post', `/user/order`, {uuid: this.uuid}).then(data => {
      this.cart = data.cart
      this.tickets = Object.values(data.cart.tickets ?? []).filter((ticket:any) => ticket.cashless === true);
      this.passes = Object.values(data.cart.passes ?? []).filter((pass:any) => pass.cashless === true);
      if (this.tickets.length == 1 && this.passes.length == 0) {
        this.handleDisplayCashless(this.tickets[0]['id'])
      }
      if (this.tickets.length == 0 && this.passes.length == 1) {
        this.handleDisplayCashlessPass(this.passes[0]['id'])
      }
    }).catch(error => {
      console.error(error);
      this.hasError = true;
    });
  }

  handleDisplayCashless(id) {
    if (this.cart && this.cart.passes && this.cart.passes[id]) {
      this.handleDisplayCashlessPass(id)
    } else {
      this.url = null
      this.selected = null
      this.hasError = false;
      if (id != 'default' && this.cart.jmCashless_endpoint) {
        axios.get(this.cart.jmCashless_endpoint+"api/zones/short/"+this.cart.tickets[id].zone+"/enabled",{withCredentials: false}).then(response => {
          if (response.data.status == 200 && response.data.enabled == true) {
            this.iframeLoading = true
            this.url = this.cart.jmCashless_endpoint+"client/"+this.cart.tickets[id].barcode+"/embed/"+this.theme
            this.selected = id
          }
        }).catch(error => {
          console.error(error);
          this.hasError = true;
        });
      }
    }
  }

  handleDisplayCashlessPass(id) {
    this.url = null
    this.selected = null
    this.hasError = false;
    if (id != 'default' && this.cart.jmCashless_endpoint) {
      const zonesList = Object.values(this.cart.tickets ?? []).filter((ticket:any) => ticket.pass == id).map((ticket: any) => ticket.zone);
      axios.post(this.cart.jmCashless_endpoint+"api/zones/short/enabled",{withCredentials: false, zone_ids:zonesList}).then(response => {
        if (Object.values(response.data).includes(true)) {
          this.iframeLoading = true
          this.url = this.cart.jmCashless_endpoint+"client/"+this.cart.passes[id].code+"/embed/"+this.theme
          this.selected = id
        }
      }).catch(error => {
        console.error(error);
        this.hasError = true;
      });
    }
  }

  render() {
    return (
      <section class="main-section">
        <div class="wrap">
          {this.cart && [
            <div class="title margin-bottom-20">
              <h1 class="title-1 text-align-center">
                <i class="icon-accounting-coins-bill margin-right-10"></i>
                {translate("Gestion de vos comptes cashless")}
              </h1>
            </div>,
            <p class="text-align-center">
              {translate("Le cashless permet de regler facilement vos achats durant l'evenement, a l'aide d'un bracelet sans contact lie a votre billet, que vous pouvez crediter des maintenant.")}
            </p>,
            <p class="text-align-center">
              {translate("Vous eviterez de faire la queue aux caisses le jour J, grace a notre partenaire JM Contactless")}
            </p>,
            <div class="select-ticket row">
              {(this.tickets.length > 0 || this.passes.length > 0) &&
                <select class="input input-lg select-lg full-width" onInput={(event:any) => this.handleDisplayCashless(event.target.value)}>
                  <option value="default">Veuillez selectionner un billet a recharger</option>
                  {this.passes.length && this.passes.map((pass: any) => {
                    return (
                      <option selected={this.selected == pass.id} value={pass.id}>
                        {pass.code + " - " + pass.firstname + " - " + pass.lastname + " - " + pass.passCategory.language.name}
                      </option>
                    );
                  })}
                  {this.tickets.length > 0 && this.tickets.map((ticket: any) => {
                    return (
                      <option selected={this.selected == ticket.id} value={ticket.id}>
                        {ticket.barcode + " - " + this.cart?.zones[ticket.zone].language.name + " - " + this.cart?.tariffs[ticket.tariff].language.name + " - " + this.cart?.tariffs[ticket.tariff].event.name + " - " + DateTime.fromFormat(this.cart?.tariffs[ticket.tariff].event.date, 'dd/MM/yyyy').toLocaleString(DateTime.DATE_MED)}
                      </option>
                    );
                  })}
                </select>
              }
              {this.tickets.length < 1 && this.passes.length < 1 &&
                <p class="text-2">
                  {translate("Vous n'avez malheureusement aucun billet compatible avec la recharge cashless.")}
                </p>
              }
              {!this.url && this.selected &&
                <p class="text-2">
                  {translate("Ce billet n'est pas compatible avec la recharge cashless.")}
                </p>
              }
            </div>,
            <div>
              {this.url &&
                <div>
                  {this.iframeLoading &&
                    <div class="iframe-loader">
                      <ike-loader/>
                    </div>
                  }
                  <iframe src={this.url} name="cashlessPartner" frameBorder="0" width="100%" class="cashlessPartner" onLoad={() => this.iframeLoading = false}></iframe>
                </div>
              }
            </div>,
          ]}
          {this.hasError &&
            <div class="frame">
              <div class="flex justify-content-center align-items-center flex-column">
                <i class="icon-alert-triangle red font-size-28 margin-bottom-20"></i>
                <p>{translate("Une erreur est survenue pendant la recuperation des informations.")}</p>
              </div>
            </div>
          }
        </div>
      </section>
    );
  }
}
